import { jsx as _jsx } from "react/jsx-runtime";
import ReactPlayer from 'react-player';
import { Container } from '../Container';
export const Video = props => {
    const { src, type } = props.node.attrs;
    const isAudio = type === null || type === void 0 ? void 0 : type.includes('audio');
    return (_jsx(Container, { ...props, children: _jsx(ReactPlayer, { url: src, controls: true, width: "100%", height: isAudio ? '50px' : '100%', config: {
                file: { forceAudio: isAudio },
            } }, void 0) }, void 0));
};
//# sourceMappingURL=Video.js.map